import { render, staticRenderFns } from "./JobGrade.vue?vue&type=template&id=873662d4&scoped=true"
import script from "./JobGrade.vue?vue&type=script&lang=js"
export * from "./JobGrade.vue?vue&type=script&lang=js"
import style0 from "./JobGrade.vue?vue&type=style&index=0&id=873662d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873662d4",
  null
  
)

export default component.exports